import React from 'react'
import InternalHeader from '~/components/Layout/components/InternalHeader'
import { useLang } from '~/hooks/useLang'
import ListAllWorkScheduleLog from './components/ListAllWorkScheduleLog'

export default function WorkScheduleLogTable() {
  const { translate } = useLang()

  return (
    <>
      <InternalHeader
        title={`${translate('Audit')}: ${translate('Scale Action Logs')}`}
      />
      <ListAllWorkScheduleLog />
    </>
  )
}
